  import { useState, useEffect } from 'react';
  import { useAuth } from '../contexts/AuthContext';
  import { Link } from 'react-router-dom';
  import { useAlert } from '../contexts/AlertContext';
  import { useConfirm } from '../contexts/AlertContext';

  export default function UserDropdown() {
    const [isOpen, setIsOpen] = useState(false);
    const { user, logout } = useAuth();
    const showAlert = useAlert();
    const confirm = useConfirm();
    
    // Szerepkörök ellenőrzése a bejelentkezett felhasználó alapján
    const isFodrasz = user?.role === 'Fodrász';
    const isRendszergazda = user?.role === 'Rendszergazda';
    const isCustomer = user?.role === 'Vásárló';
    const isAdminValamilyen = isFodrasz;

    // Kattintás kívülre bezárja a menüt
    useEffect(() => {
      const closeMenu = () => setIsOpen(false);
      if (isOpen) {
        window.addEventListener('click', closeMenu);
      }
      return () => window.removeEventListener('click', closeMenu);
    }, [isOpen]);

    if (!user) return null;

    return (
      <div className="relative inline-block text-left" onClick={(e) => e.stopPropagation()}>
        {/* Profil Gomb */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center gap-3 p-1.5 pr-4 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-xl transition-all shadow-sm border border-gray-100 dark:border-gray-700 group"
        >
          <div className="w-10 h-10 bg-gradient-to-tr from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center text-white font-bold shadow-inner">
            {user.name.charAt(0).toUpperCase()}
          </div>
          <div className="hidden md:block text-left">
            <p className="text-xs font-black text-gray-800 dark:text-white uppercase tracking-tighter leading-none mb-1 transition-colors">
              {user.name}
            </p>
            <span className={`text-[9px] px-2 py-0.5 rounded-full font-bold uppercase transition-colors ${
              isRendszergazda ? 'bg-purple-100 dark:bg-purple-900/50 text-purple-600 dark:text-purple-300' : 
              isFodrasz ? 'bg-amber-100 dark:bg-amber-900/50 text-amber-600 dark:text-amber-300' : 'bg-blue-100 dark:bg-blue-900/50 text-blue-600 dark:text-blue-300'
            }`}>
              {user.role}
            </span>
          </div>
          <svg className={`w-4 h-4 text-gray-400 dark:text-gray-300 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {/* Dropdown Menü */}
        {isOpen && (
          <div className="absolute right-0 mt-3 w-[calc(100vw-1rem)] max-w-72 bg-white dark:bg-gray-800 rounded-[1rem] shadow-2xl border border-gray-100 dark:border-gray-700 overflow-hidden z-[100] animate-in fade-in zoom-in duration-200 transition-colors">
            
            <div className="p-4 bg-gray-50/50 dark:bg-gray-900/50 border-b border-gray-100 dark:border-gray-700">
              <p className="text-[10px] font-black text-gray-400 dark:text-gray-500 uppercase tracking-widest mb-1">Bejelentkezve mint</p>
              <p className="text-sm font-bold text-gray-800 dark:text-gray-200 truncate">{user.email}</p>
            </div>

            <div className="py-0">
              {/* 1. ÚJ FOGLALÁS - Csak vendégeknek (Vásárló) */}
              {!isFodrasz && !isRendszergazda && (
                <Link
                  to="/foglalas"
                  onClick={() => setIsOpen(false)}
                  className="flex items-center px-6 py-4 text-gray-700 dark:text-gray-200 hover:bg-blue-50 dark:hover:bg-blue-900/30 transition-all font-semibold group border-b border-gray-100 dark:border-gray-700"
                >
                  <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900/50 rounded-xl flex items-center justify-center mr-4 group-hover:scale-110 transition-transform">
                    <span className="text-xl">📅</span>
                  </div>
                  <div>
                    <div className="font-bold">Új foglalás</div>
                  </div>    
                </Link>
              )}

              {/* 2. ADMIN DASHBOARD - Fodrásznak */}
              {isAdminValamilyen && ( 
                <Link
                  to="/fodrasz-panel"
                  onClick={() => setIsOpen(false)}
                  className="flex items-center px-6 py-4 text-gray-700 dark:text-gray-200 hover:bg-amber-50 dark:hover:bg-amber-900/30 transition-all font-semibold group border-b border-gray-100 dark:border-gray-700"
                >
                  <div className="w-10 h-10 bg-amber-100 dark:bg-amber-900/50 rounded-xl flex items-center justify-center mr-4 group-hover:scale-110 transition-transform">
                    <span className="text-xl">✂️</span>
                  </div>
                  <div>
                    <div className="font-bold">Statisztika és beállítások</div>
                  </div>
                </Link>
              )}

              {/* 3. SUPER ADMIN PANEL - Csak a Rendszergazda látja */}
              {isRendszergazda && (
                <Link
                  to="/rendszergazda-panel"
                  onClick={() => setIsOpen(false)}
                  className="flex items-center px-6 py-4 text-gray-700 dark:text-gray-200 hover:bg-purple-50 dark:hover:bg-purple-900/30 transition-all font-semibold group border-b border-gray-100 dark:border-gray-700"
                >
                  <div className="w-10 h-10 bg-purple-100 dark:bg-purple-900/50 rounded-xl flex items-center justify-center mr-4 group-hover:scale-110 transition-transform">
                    <span className="text-xl">🛡️</span>
                  </div>
                  <div>
                    <div className="font-bold text-purple-700 dark:text-purple-400">Rendszergazda Panel</div>
                  </div>
                </Link>
              )}

              {/* Az menű kiegészítése role alapján  */}
              {!isRendszergazda && (
                <>
                  {isCustomer && (
                    <Link
                      to="/sajat-fogalalsok"
                      onClick={() => setIsOpen(false)}
                      className="flex items-center px-6 py-4 text-gray-700 dark:text-gray-200 hover:bg-blue-50 dark:hover:bg-blue-900/30 transition-all font-semibold group border-b border-gray-100 dark:border-gray-700"
                    >
                      <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900/50 rounded-xl flex items-center justify-center mr-4 group-hover:scale-110 transition-transform">
                        <span className="text-xl">📋</span>
                      </div>
                      <div>
                        <div className="font-bold">Foglalásaim</div>
                      </div>
                    </Link>
                  )}

                <Link
                  to="/profil"
                  onClick={() => setIsOpen(false)}
                 className="flex items-center px-6 py-4 text-gray-700 dark:text-gray-200 hover:bg-blue-50 dark:hover:bg-blue-900/30 transition-all font-semibold group border-b border-gray-100 dark:border-gray-700" 
                >
                  <div className="w-10 h-10 bg-gray-100 dark:bg-gray-700 rounded-xl flex items-center justify-center mr-4 group-hover:bg-gray-200 dark:group-hover:bg-gray-600 transition-colors ">
                    <span className="text-xl">👤</span>
                  </div>
                  <div>
                    <div className="font-bold">Profilom</div>
                  </div>
                </Link>
                </> 
              )}

              <button
                onClick={async () => {
                  if (await confirm("Biztosan ki szeretnél jelentkezni?")) {
                    logout();
                    showAlert("Sikeres kijelentkezés!");
                    setIsOpen(false);
                  }
                }}
                className="flex items-center w-full px-6 py-4 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/30 transition-all font-semibold group"
              >
                <div className="w-10 h-10 bg-red-100 dark:bg-red-900/50 rounded-xl flex items-center justify-center mr-4 group-hover:bg-red-200 dark:group-hover:bg-red-900/80 transition-colors">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                </div>
                <div className="text-left">
                  <div className="font-bold">Kijelentkezés</div>
                </div>
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }